// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"component-stickytool"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M3 21L3 3L8 3L8 21H3Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 21L3 3L8 3L8 21H3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 7V3H21L21 21H12V17M15 9.5L12.5 12L15 14.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ComponentStickytoolIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-stickytool',
    ref,
    icon: element,
  },
));

ComponentStickytoolIcon.displayName = 'ComponentStickytoolIcon';

export default ComponentStickytoolIcon;
